import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 16, height = 16, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 16 16' class={customClass}>
  <path d='M0.666992 14H15.3337L8.00033 1.33331L0.666992 14ZM8.66699 12H7.33366V10.6666H8.66699V12ZM8.66699 9.33331H7.33366V6.66665H8.66699V9.33331Z' fill={color} />
</svg>
